import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceParaNewline'
})
export class ReplaceParaNewlinePipe implements PipeTransform {

    transform(value: string): string {
    return value.replace(/§/g, "\n");
  }

}
